import type { FaireProductEntity } from "../../entity_types/product";

export const p_sgw3x44b7j: FaireProductEntity = {
  token: "p_sgw3x44b7j",
  type: "product",
  name: "truth for today love cards",
  brandToken: "b_mmdanrh9jf",
  brandName: "emily lex studio",
  imageUrl:
    "https://cdn.faire.com/fastly/087e4542bd6d1675cc09ce749c96c621d76dd71c12b4b1cc71daf71825efcb76.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c8f059dabd470f0801ad5a737a80b197a4f8509949c96e2724f45a995cd75d4d.jpeg",
    "https://cdn.faire.com/fastly/85a6223ecb25ef206aadc41044e44c100d425fb3bb411bdd7ff9dd87c00e0e18.jpeg",
    "https://cdn.faire.com/fastly/11c5b6b060aaef4ac2f05b26d78314f74a95618aa5e1cccc1246b1c446d5f050.jpeg",
    "https://cdn.faire.com/fastly/bb612a9ebe7a558f0ce4809f7ed2a3ac45e0a817861edb170f63d6112ae5c5e9.jpeg",
    "https://cdn.faire.com/fastly/519563678dad0d827d9c2782da12d88555cd5a2b9ed4a082ff2a4df4287c3fd9.jpeg",
  ],
  priceDollars: 12,
  description:
    "Celebrate the truth of God's love with this set of 31 cards, each featuring a favorite Bible verse about love paired with a charming watercolor illustration. Thoughtfully designed to encourage, inspire, and uplift, these cards blend timeless truth with artistic beauty.\n\nDisplay them throughout your home as a gentle reminder of God’s enduring love and His call for us to love others. Use them as daily or weekly reflections, commit the verses to memory, or share them with friends for moments of encouragement. Slip one into a note, keep a few by your bedside, tie them to gifts, or display them on your desk or mirror.\n\nPerfect for personal use or gifting, especially for weddings, anniversaries, or anyone needing a little extra reminder of God's love.\n",
  tags: [],
  msrpDollars: 24,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-14T07:14:51.533Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
